import { LocalStorageKey } from '@/modules/core/app/constants/app.constants';
import LocalStorage from '@/modules/core/app/helpers/LocalStorage';
import Logger from '@/modules/core/app/helpers/Logger';
import { ClaraForPlannersLauncherPosition } from '@/modules/ai/interfaces/ClaraForPlannersLauncherPosition';

export class ClaraForPlannersLauncherPositionService {
  load(): ClaraForPlannersLauncherPosition | null {
    const rawValue: unknown = LocalStorage.getItem(
      LocalStorageKey.CLARA_FOR_PLANNERS_LAUNCHER_POSITION
    );

    if (typeof rawValue !== 'string') {
      return null;
    }

    try {
      const parsed: Partial<ClaraForPlannersLauncherPosition> = JSON.parse(rawValue);

      if (!Number.isFinite(parsed.right) || !Number.isFinite(parsed.bottom)) {
        return null;
      }

      return { right: parsed.right as number, bottom: parsed.bottom as number };
    } catch {
      return null;
    }
  }

  save(position: ClaraForPlannersLauncherPosition): void {
    try {
      LocalStorage.setItem(
        LocalStorageKey.CLARA_FOR_PLANNERS_LAUNCHER_POSITION,
        JSON.stringify(position)
      );
    } catch (error: unknown) {
      Logger.errors('Failed to save the Clara launcher position:', error);
    }
  }
}

export default new ClaraForPlannersLauncherPositionService();
